var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 8 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.873 16.107H1.646V8.303H.03V5.612h1.615V3.997c0-2.194.91-3.499 3.497-3.499h2.155v2.69H5.95c-1.007 0-1.074.376-1.074 1.077l-.004 1.347h2.441l-.286 2.69H4.873v7.805Z",
  fill: "currentColor"
})));

export default SvgIconFacebook;